export default __webpack_public_path__ + "static/media/ISF_D.d118ea35.svg";